import { useTLang } from 'intl/intl';

import type { UserTagType } from 'shared/domain';

export function useUserTagLang({ userTag }: Props) {
  const label = useTLang({
    id: {
      new: 'orderDetailDialogCustomerBox.newUserLabel',
      pro: 'orderDetailDialogCustomerBox.highValueUserLabel',
      own: 'orderDetailDialogCustomerBox.propioLabel',
    }[userTag],
  });

  return {
    label,
  };
}

interface Props {
  userTag: UserTagType;
}
